// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"364":"1fab23be4a0bcac3","409":"d0894dcc9a9f8858","716":"2df118651bfe9317","805":"1bf56a96f3fdec15","842":"fc8f617bc2e178e1"}[chunkId] + ".js";
};